import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 kötet', '5 bónusz', '240 oldal', '1–7. osztály'];
const reassurances = ['Azonnali letöltés', 'Nyomtatható PDF-fájlok', '7 napos elégedettségi garancia'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsmth3jo8k3">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbtwnm1seqbp" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ebxu7r8qn6y9">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1myvwg1ht3a">
          A technikaóráid már <em className="text-red-700" data-id="element-118" data-mp="1o5y7whi35kil">ma készen lehetnek.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="224ee87c1d907">
          Ahelyett, hogy projekteket keresgélnél, minden sablont magad rajzolnál meg, és a vasárnap estéidet óravázlatokkal töltenéd, egy rendszerezett technikacsomagod lesz az egész tanévre. Több idő arra, ami igazán számít:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s6s1c6od23ek">
          A gyerekek. A tanításod. Az életed az iskolán kívül.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="123n0mrsgk7tw">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="162m9uol82qr5">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b2i621nohdw5">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fus27zfdza6v">Egyszeri fizetés – nincs előfizetés.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1ks1q3an4ndsl">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1pspowihlkyxd" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1puaio5w38du6">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3quoycxuuozqg">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qux84gvofoxf" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}